import React, { PureComponent, ReactNode } from "react"
import { connect, DispatchProp } from "react-redux"
import { ITown } from "../../models"
import { IStoreState } from "../../store/states"
import { Application } from "../../config"
import { Button, MenuItem, Modal, Spinner } from "../../components"
import { LiteralsService, UserService } from "../../services"
import StyledDiv from './styles'
import { Dispatch } from 'redux'
import { fetchClientInfoAction, setAreaChangedAction, setNotificationAction, setSelectedAreaAction, setUserInfoAction } from "../../store/actions"

interface IProps extends DispatchProp<any> {
  towns: ITown[]
  selectedTownId: number | null
  isExperienced: boolean
  userTownId: number
  isLoading: boolean
  documentationRequired: boolean
  isFetchingAreas: boolean
}

const { isNemi } = Application

class TownsModal extends PureComponent<IProps> {

  private get modalContent(): ReactNode {
    const { towns, selectedTownId, isFetchingAreas, dispatch } = this.props

    const townsItems = towns.sort((a, b) => a.name.localeCompare(b.name)).map(town => (
      <section key={town.id} className="row">
        <MenuItem
          key={town.id}
          label={town.name}
          onClick={ () => this.handleAreaSelection(town.id) }
          icon={ selectedTownId === town.id ? 'checkLanguage' : undefined }
        />
      </section>
    ))

    return (
      <StyledDiv>
        <h3 className="modal-title"> { LiteralsService.get('chooseArea', true) } </h3>
        <section className="towns">
          { isFetchingAreas ? <Spinner/> : townsItems }
        </section>
        <footer>
          <Button 
            title={ LiteralsService.get('save', true) }
            onPress={ () => this.handleSaveArea(selectedTownId, dispatch) }
            className={ 'saveButton' }
            isDisabled={ !selectedTownId || isFetchingAreas }
            filled
            upper
          />
        </footer>
      </StyledDiv>
    )
  }

  public render(): ReactNode {
    const { towns, isExperienced, documentationRequired } = this.props

    if ( isExperienced || !towns.length || !isNemi || documentationRequired) return null
    return (
      <Modal isHidden={ false }>
        { this.modalContent }
      </Modal>
    )
  }

  private handleAreaSelection(townId: number): void {
    this.props.dispatch(setSelectedAreaAction(townId))
  }

  private async handleSaveArea(id: number | null, dispatch: Dispatch): Promise<void> {
    if (!id) return

    try {
      await UserService.updateTown(id)
      const user = await UserService.getInfo()
      dispatch(setUserInfoAction(user))
      dispatch(fetchClientInfoAction())
      dispatch(setAreaChangedAction())
      dispatch(
        setNotificationAction({
          isError: false,
          label: LiteralsService.get('areaChanged', true)
        })
      )
    } catch (error) {
      dispatch(
        setNotificationAction({
          isError: true,
          label: LiteralsService.get('serverError', true)
        })
      )
    }
  }
}


const mapStateToProps = ({ configuration, userInfo }: IStoreState) => ({
  towns: configuration.areas,
  selectedTownId: configuration.selectedAreaId,
  isExperienced: userInfo.experienced,
  userTownId: userInfo.town.id,
  isLoading: userInfo.isLoadingUserInfo,
  isFetchingAreas: configuration.isFetchingAreas,
  documentationRequired: userInfo.documentationRequired
})

export default connect(mapStateToProps)(TownsModal)